import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
`;

export const Option = styled.button<{ $isActive: boolean }>`
  flex: 0 0 auto;
  padding: 0 8px;
  font: inherit;
  font-size: 12px;
  font-weight: 400;
  outline: none;
  color: ${({ $isActive }) =>
    $isActive ? theme.colors.mainBlue : theme.colors.secondary800};
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;
